import { SafeJSON } from './../../shared/safe-json';

export class OtherAllegation {
    private json: any;

    constructor(json: any) {
        this.json = json;
    }

    getOtherPleadingTypeDesc(): string {
        return SafeJSON.get('juvenilePleadingBean.pleadingTypeDesc', this.json);
    }

    getOtherPleadingDate(): string {
        return SafeJSON.get('juvenilePleadingBean.jaaPleadingDate', this.json);
    }

    getOtherPleadingTime(): string {
        return SafeJSON.get('juvenilePleadingBean.pleadingTime', this.json);
    }

    getOtherAllegationDescription(): string {
        return SafeJSON.get('description', this.json);
    }

    getOtherAllegationOffenseDate(): string {
        return SafeJSON.get('offenseDate', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/other-allegations.ts